<div class="home">
  <app-my-own-stories></app-my-own-stories>
  <app-stories></app-stories>
</div>
